import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
declare var window:any;
@Injectable({
  providedIn: 'root'
})
export class RenderService {
  unbindScripts() {
    window.portalBindingHandler?.unbindScripts();
  }
  bindMainScripts() {
    this.unbindScripts();

    window.bindCommonScript();
    window.bindCallFunctions();
    window.youtubePopupHandler?.init();
    window.podcastPopup?.init();
  }
  bindMessagePopups() {
    window.MessagePopup?.init();
  }
}
